'use client';
import React, { useEffect, useRef, useState } from 'react';

export default function HeroSection() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="hero">
      <div className="dentaire-container">
        <div className="row align-items-center">
          {/* Left Content */}
          <div className="col-lg-6">
            <div className="hero-content">
              <div className="section-title">
                <h1
                  style={{
                    fontSize: '54px',
                    fontWeight: 700,
                    lineHeight: '1.2em',
                    color: 'var(--primary-color)',
                    opacity: visible ? 1 : 0,
                    transform: visible ? 'translateY(0)' : 'translateY(30px)',
                    transition: 'opacity 0.8s ease, transform 0.8s ease'
                  }}>
                  
                  Experience{' '}
                  <span style={{ color: 'var(--accent-color)' }}>Médicale Africaine</span>{' '}
                  à Votre Service
                </h1>
                <p
                  style={{
                    marginTop: '20px',
                    marginBottom: 0,
                    opacity: visible ? 1 : 0,
                    transform: visible ? 'translateY(0)' : 'translateY(30px)',
                    transition: 'opacity 0.8s ease 0.25s, transform 0.8s ease 0.25s'
                  }}>
                  
                  COSA, Compagnie de Santé Africaine, est un centre médical innovant et de haute qualité, conçu pour répondre aux besoins croissants de services de santé privés. Un plateau technique de pointe pour élever les standards de santé en Côte d'Ivoire.
                </p>
              </div>

              <div
                className="hero-content-body"
                style={{
                  opacity: visible ? 1 : 0,
                  transform: visible ? 'translateY(0)' : 'translateY(30px)',
                  transition: 'opacity 0.8s ease 0.5s, transform 0.8s ease 0.5s'
                }}>
                
                <a href="#" className="btn-default">prendre rendez-vous</a>
              </div>

              <div
                className="google-rating"
                style={{
                  opacity: visible ? 1 : 0,
                  transform: visible ? 'translateY(0)' : 'translateY(30px)',
                  transition: 'opacity 0.8s ease 0.75s, transform 0.8s ease 0.75s'
                }}>
                
                <ul>
                  <li>Note Google <span>4.9</span></li>
                  <li>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                  </li>
                  <li>basé sur 312 avis</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="col-lg-6">
            <div className="hero-image">
              <div className="hero-img">
                <figure>
                  <img src="/assets/images/hero-doctor.png" alt="Dental doctor smiling" />
                </figure>
              </div>

              {/* Doctor Tag */}
              <div className="export-dantist-box">
                <div className="icon-box">
                  <figure className="image-anime">
                    <img src="/assets/images/dentist-doctor-img.png" alt="Dr. Clara Lee dentist" />
                  </figure>
                </div>
                <div className="export-dantist-content">
                  <h3>Dr. Pierre Montagnier</h3>
                  <p>Fondateur, 1954</p>
                </div>
              </div>

              {/* Icon List */}
              <div className="hero-icon-list">
                <div className="hero-icon-box-1">
                  <img src="https://html.awaikenthemes.com/dentaire/images/icon-hero-theeth-1.svg" alt="Dental icon" />
                </div>
                <div className="hero-icon-box-2">
                  <img src="https://img.rocket.new/generatedImages/rocket_gen_img_1db1e6211-1766927211422.png" alt="Dental icon" />
                </div>
                <div className="hero-icon-box-3">
                  <img src="https://img.rocket.new/generatedImages/rocket_gen_img_1db1e6211-1766927211422.png" alt="Dental icon" />
                </div>
              </div>

              {/* Star Icon */}
              <div className="icon-star-image">
                <img src="https://html.awaikenthemes.com/dentaire/images/icon-star.svg" alt="Star decoration" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>);

}